import { Typography } from "@packages/ds";
import styled from "styled-components";

export const ServiceConfigurationRoot = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  flex-shrink: 0;
  margin-top: 8px;
`;

export const Code = styled(Typography.Code)`
  margin: unset;
`;
